import { ExpandableBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/expandableBlock/expandableBlock.layout'
import { NestedBlock } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/blocks.state'
import 'intersection-observer'
import * as React from 'react'
import { Updater, IOWidget, fromJSX } from 'widgets-for-react'
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState, Link } from '../../../../cms/blocks/types.gen'

export type expandBlockProps = {
  index: number
  title?: string
  intro?: string
  items: expandProps[]
  link?: Link
}

export type expandProps = {
  index: number
  block: NestedBlock[]
  open: boolean
  title: string
  subtitle?: string
  text?: string
  useSVGIcons: boolean
}

export function expandBlock<customBlockData extends { kind: customBlockData['kind'] }, extraImages>(
  props: expandBlockProps
): (
  s: CMSState
) => IOWidget<PublicSiteState, Updater<CMSState>> {
  return (s: CMSState) => (public_state: PublicSiteState) =>
    fromJSX((onDone) => {
        return (
          <ExpandableBlockLayout
            id={props.index.toString()}
            title={props.title}
            intro={props.intro}
            isPrintMode={false}
            acceptVideoCookie={() => {}}
            videoCookieAccepted={false}
            items={props.items.map((item) => ({
              title: item.title,
              description: item.subtitle,
              body: item.text,
              nestedBlocks: item.block
            }))}
            primaryUpdater={
              props.link
                ? {
                    ...props.link,
                    isExternal: props.link.is_link_external
                  }
                : undefined
            }
          />
        )
      }
    )
}
